import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { FuseNavigationProps } from '../FuseNavigation';
import { FuseNavItemType } from '../types/FuseNavItemType';
import FuseNavItem from '../FuseNavItem';
import SettingsAppNavigation from '@/pages/apps/settings/settings/SettingsAppNavigation';

const StyledList = styled(List)(({ theme }) => ({
	'& .fuse-list-item': {
		'&:hover': {
			backgroundColor: 'rgba(0,0,0,.04)',
			...theme.applyStyles('dark', {
				backgroundColor: 'rgba(255, 255, 255, 0.05)'
			})
		},
		'&:focus:not(.active)': {
			backgroundColor: 'rgba(0,0,0,.05)',
			...theme.applyStyles('dark', {
				backgroundColor: 'rgba(255, 255, 255, 0.06)'
			})
		}
	},
	'& .fuse-list-item-text-primary': {
		lineHeight: '1'
	},
	'&.active-square-list': {
		'& .fuse-list-item, & .active.fuse-list-item': {
			width: '100%',
			borderRadius: '0'
		}
	},
	'&.dense': {}
}));

/**
 * FuseNavVerticalLayout2 component represents a vertical navigation layout with material UI elements.
 * It displays the navigation object in the structured vertical menu and allows to handle onClick events for each navigation item.
 */
function FuseNavVerticalLayout2(props: FuseNavigationProps) {
	const { active, dense, className, onItemClick } = props;

	function handleItemClick(item: FuseNavItemType) {
		onItemClick?.(item);
	}

	return (
		<StyledList
		className={clsx(
			'navigation whitespace-nowrap px-3 py-0',
			`active-${active}-list`,
			dense && 'dense',
			className
		)}
	>
		{SettingsAppNavigation.children.map((_item, index) => (
			<FuseNavItem
				key={_item.id}
				type={`vertical-${_item.type}`}
				item={{..._item, hasPermission: true}}
				nestedLevel={0}
				onItemClick={handleItemClick}
			/>
		))}
	</StyledList>
	);
}

export default FuseNavVerticalLayout2;
